<template>
    <el-dialog
            :title="'补卡'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm"  ref="dataForm"
                 label-width="150px">
            <el-row>
                <el-col :span="12"><el-form-item label="申请人姓名" prop="username">
                    <div class="min-input-class">{{dataForm.username}}</div>
                </el-form-item></el-col>
                <el-col :span="12"><el-form-item label="申请时间" prop="tjsj">
                    <div class="min-input-class">{{dataForm.tjsj}}</div>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item label="审核结果"  prop="status">
                    <div class="min-input-class">
                        <el-tag v-if="dataForm.status=='0'" type="danger">未审核</el-tag>
                        <el-tag v-else-if="dataForm.status=='1'" type="danger">不通过</el-tag>
                        <el-tag v-else-if="dataForm.status=='2'" type="success">审批通过</el-tag>
                        <el-tag v-else-if="dataForm.status=='3'" type="success">审核通过</el-tag>
                        <el-tag v-else type="info">已撤销</el-tag>
                        <!-- <el-tag v-if="dataForm.status=='0'" type="danger">待审核</el-tag>
                        <el-tag v-if="dataForm.status=='1' || dataForm.status=='3'" type="success">已审核</el-tag>
                        <el-tag v-if="dataForm.status=='2'" type="success">已审批</el-tag> -->
                    </div>
                </el-form-item>
               </el-col>
                <el-col :span="12"><el-form-item label="补卡时间"  prop="kssj">
                    <div class="min-input-class">{{dataForm.bksj}}</div>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="12"><el-form-item label="审核人">
                    <div class="min-input-class">{{dataForm.shrxm}}</div>
                </el-form-item></el-col>
                <el-col :span="12"> <el-form-item label="审核时间"  >
                    <div class="min-input-class">{{dataForm.shsj}}</div>
                </el-form-item></el-col>
            </el-row>

            <el-row>
                <el-col :span="12">  <el-form-item label="审批人" >
                    <div class="min-input-class">{{dataForm.sprxm}}</div>
                </el-form-item></el-col>
                <el-col :span="12"><el-form-item label="审批时间" >
                    <div class="min-input-class">{{dataForm.spsj}}</div>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="24"><el-form-item label="补卡事由" >
                    <div class="min-input-class">{{dataForm.bksy}}</div>
                </el-form-item></el-col>
            </el-row>
            <el-row>
                <el-col :span="24"><el-form-item label="流程" >
                    <el-timeline :reverse="true">
                        <el-timeline-item
                                v-for="(activity, index) in activities"
                                :key="index"
                                :color="activity.color"
                                :size="'large'"
                                :timestamp="activity.timestamp">
                            {{activity.content}}
                        </el-timeline-item>
                    </el-timeline>
                </el-form-item></el-col>
            </el-row>
        </el-form>
        <div v-if="showBtn" style="width: 100%; height: 50px;text-align: center;">
            <el-button style="margin: 0 30px; width: 30%;" type="success" @click="passAndReject('ty')">通过</el-button>
            <el-button style="margin: 0 30px; width: 30%;" type="danger" @click="passAndReject('jj')">驳回</el-button>
        </div>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {

        data () {
            return {

                visible: false,
                activities:[],
                dataForm: {
                    id: '',
                    userid: '',
                    username: '',
                    qjlx: '',
                    bksj: '',
                    jssj: '',
                    qjsc: '',
                    shrid: '',
                    shrxm: '',
                    shsj: '',
                    sprid: '',
                    sprxm: '',
                    spsj: '',
                    status: '',
                    bksy: '',
                    tjsj: '',
                    qjlxmc: '',
                    bmmc: '',
                    workNumber: ''
                },
                showBtn: false
            }
        },
        methods: {
            init (val) {
                this.dataForm = val
                this.visible = true
                this.activities=[]
                if (val.shtype == 'dsh' || val.shtype == 'dsp') {
                    this.showBtn = true
                } else {
                    this.showBtn = false
                }
                this.$nextTick
                (() => {
                    console.log('111111111111')
                    if(this.dataForm.status ==='0') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                    } else if( this.dataForm.status ==='1') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        var obj1={}
                        if (this.dataForm.shrid) {
                            obj1.content = this.dataForm.shrxm+' 审核不通过'
                            obj1.timestamp = this.dataForm.shsj
                        } else {
                            obj1.content = this.dataForm.sprxm+' 审批不通过'
                            obj1.timestamp = this.dataForm.spsj
                        }
                        obj1.color='#e81018'
                        this.activities.push(obj1);
                    } else if( this.dataForm.status ==='3') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        if(this.dataForm.shrxm){
                            var obj1={}
                            obj1.content = this.dataForm.shrxm+' 审核通过'
                            obj1.timestamp = this.dataForm.shsj
                            obj1.color='#0bbd87'
                            this.activities.push(obj1);
                        }
                    }else if( this.dataForm.status ==='2') {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        if (this.dataForm.shrid) {
                            var obj1 = {}
                            obj1.content = this.dataForm.shrxm + ' 审核通过'
                            obj1.timestamp = this.dataForm.shsj
                            obj1.color = '#0bbd87'
                            this.activities.push(obj1);
                        }
                        var obj2={}
                        obj2.content = this.dataForm.sprxm+' 审批通过'
                        obj2.color='#0bbd87'
                        obj2.timestamp = this.dataForm.spsj
                        this.activities.push(obj2);
                    }else  {
                        var obj ={};
                        obj.timestamp = this.dataForm.tjsj;
                        obj.content = this.dataForm.username + ' 申请补卡';
                        this.activities.push(obj);
                        var obj2={}
                        obj2.content = this.dataForm.username+' 撤销'
                        obj2.timestamp = ''
                        obj2.color='#e81018'
                        this.activities.push(obj2);
                    }
                    console.log("流程图数据格式为：",this.activities)
                })

            },
            passAndReject(type) {
                console.log('补卡信息', this.dataForm);
                var msg = ''
                if (type == 'ty') {
                    msg = '通过'
                } else {
                    msg = '驳回'
                }
                this.$confirm(`确定进行[`+msg+`]操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (type == 'ty') {
                        if (this.dataForm.shrid && this.dataForm.status == '0') {
                            this.dataForm.status = 3
                        } else if (this.dataForm.shrid && this.dataForm.status == '4') {
                            this.dataForm.status = 6
                        }else{
                            this.dataForm.status = 2;
                        }
                    } else {
                        if(this.dataForm.status == '4'){
                            this.dataForm.status = 2
                        }else{
                            this.dataForm.status = 1
                        }
                    }
                    console.log("要保存的审批信息-djkldfgfc-为：",this.dataForm)
                    this.$http({
                        url: `/bjba/xxsh/saveBKxx`,
                        method: 'post',
                        header: {
                            contentType: 'application/x-www-form-urlencoded'
                        },
                        params: this.dataForm
                    }).then(({data}) => {
                        console.log("审核成功返回-jdlkgjfk信息：",data)
                        if (data) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500
                            })
                            this.visible = false
                            this.$emit('refreshDataList')
                        } else {
                            this.$message({
                                message: data.message,
                                type: 'error',
                                duration: 1500
                            })
                        }
                    })
                    .catch(err => {
                        this.$message({
                            message: '操作失败',
                            type: 'error',
                            duration: 1500
                        })
                    });
                }).catch(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
